<template>
  <div class="dashboard-container">
    <!-- 欢迎栏 -->
    <div class="welcome-section">
      <div class="welcome-text">
        <h2>欢迎使用数据采集平台</h2>
        <!-- <p>{{ NowDate }}</p> -->
      </div>
    </div>

    <!-- 设备状态统计卡片 -->
    <el-row :gutter="20" class="stats-row">
      <el-col :xs="24" :sm="12" :md="6">
        <div class="stat-card stat-blue">
          <div class="stat-icon">
            <i class="el-icon-video-play"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ deviceStatus.Production || 0 }}</div>
            <div class="stat-label">生产中</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="6">
        <div class="stat-card stat-orange">
          <div class="stat-icon">
            <i class="el-icon-stopwatch"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ deviceStatus.Standby || 0 }}</div>
            <div class="stat-label">待机中</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="6">
        <div class="stat-card stat-red">
          <div class="stat-icon">
            <i class="el-icon-warning"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ deviceStatus.Fault || 0 }}</div>
            <div class="stat-label">故障中</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="6">
        <div class="stat-card stat-gray">
          <div class="stat-icon">
            <i class="el-icon-video-pause"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ deviceStatus.Shutdown || 0 }}</div>
            <div class="stat-label">关机中</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 快捷入口 -->
    <div class="quick-access-section" v-if="hasQuickAccess">
      <!-- 监控分析区块 -->
      <div class="menu-block" v-if="hasMenuPermission('monitor', 'monitor')">
        <div class="block-header">
          <div class="block-icon monitor-icon">
            <i class="el-icon-monitor"></i>
          </div>
          <div class="block-title">监控分析</div>
        </div>
        <div class="block-content">
          <div class="menu-item" v-for="menu in getMenusByKeyword('监控分析')" :key="menu.MenuId" @click="navigateToMenu(menu)">
            <div class="menu-item-icon" :class="getMenuIconClass(menu)">
              <i :class="getMenuIcon(menu)"></i>
            </div>
            <div class="menu-item-text">{{ menu.MenuName }}</div>
          </div>
          <div class="no-menu" v-if="getMenusByKeyword('监控分析').length === 0">
            暂无子菜单
          </div>
        </div>
      </div>

      <!-- 设备管理区块 -->
      <div class="menu-block" v-if="hasMenuPermission('facility', 'equipment')">
        <div class="block-header">
          <div class="block-icon facility-icon">
            <i class="el-icon-setting"></i>
          </div>
          <div class="block-title">设备管理</div>
        </div>
        <div class="block-content">
          <div class="menu-item" v-for="menu in getMenusByKeyword('设备管理')" :key="menu.MenuId" @click="navigateToMenu(menu)">
            <div class="menu-item-icon" :class="getMenuIconClass(menu)">
              <i :class="getMenuIcon(menu)"></i>
            </div>
            <div class="menu-item-text">{{ menu.MenuName }}</div>
          </div>
          <div class="no-menu" v-if="getMenusByKeyword('设备管理').length === 0">
            暂无子菜单
          </div>
        </div>
      </div>

      <!-- 人力管理区块 -->
      <!-- <div class="menu-block" v-if="hasMenuPermission('personnel', 'employee')">
        <div class="block-header">
          <div class="block-icon personnel-icon">
            <i class="el-icon-user-solid"></i>
          </div>
          <div class="block-title">人力管理</div>
        </div>
        <div class="block-content">
          <div class="menu-item" v-for="menu in getMenusByKeyword('人力管理')" :key="menu.MenuId" @click="navigateToMenu(menu)">
            <div class="menu-item-icon" :class="getMenuIconClass(menu)">
              <i :class="getMenuIcon(menu)"></i>
            </div>
            <div class="menu-item-text">{{ menu.MenuName }}</div>
          </div>
          <div class="no-menu" v-if="getMenusByKeyword('人力管理').length === 0">
            暂无子菜单
          </div>
        </div>
      </div> -->
    </div>

  </div>
</template>

<script>
import equipmentApi from '@/api/ba/equipment'

export default {
  name: 'home',
  data() {
    return {
      isMB: this.$store.state.isMB,
      api: require('@/api/sy/user').default,
      deviceStatus: {
        Production: 0,
        Standby: 0,
        Fault: 0,
        Shutdown: 0
      },
      NowDate: this.$commonJs.getToday(),
      refreshTimer: null
    }
  },
  computed: {
    // 判断是否有快捷入口
    hasQuickAccess() {
      return this.hasMenuPermission('monitor', 'monitor') ||
             this.hasMenuPermission('facility', 'equipment') ||
             this.hasMenuPermission('personnel', 'employee')
    }
  },
  mounted() {
    this.getData()
    // 设置5分钟定时刷新
    this.refreshTimer = setInterval(() => {
      this.getData()
    }, 300000) // 5分钟 = 300000毫秒
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  },
  methods: {
    getData() {
      // 获取设备状态统计
      this.getDeviceStatus()
    },
    getDeviceStatus() {
      equipmentApi.getOperatingTypes({}).then(res => {
        if (res.Data) {
          this.deviceStatus.Production = res.Data.onLineCount || 0
          this.deviceStatus.Standby = res.Data.waitCount || 0
          this.deviceStatus.Fault = res.Data.faultCount || 0
          this.deviceStatus.Shutdown = res.Data.offLineCount || 0
        }
      }).catch(err => {
        console.error('获取设备状态失败:', err)
      })
    },
    // 判断是否有菜单权限
    hasMenuPermission(module, pageKeyword) {
      const menus = this.$store.state.sys.permissionMenus
      if (!menus || menus.length === 0) return false

      // 检查是否存在该模块的父菜单
      const modulePath = `/${module}`
      return menus.some(menu => menu.FullPath === modulePath)
    },
    // 根据父菜单路径获取子菜单列表
    getMenusByParentPath(parentPath) {
      const menus = this.$store.state.sys.permissionMenus
      if (!menus || menus.length === 0) return []

      // 找到所有以父路径开头的菜单（排除父菜单本身）
      return menus.filter(menu => {
        return menu.FullPath &&
               menu.FullPath.startsWith(parentPath) &&
               menu.FullPath !== parentPath &&
               menu.FullPath.length > parentPath.length &&
               !menu.FullPath.substring(parentPath.length + 1).includes('/')
      })
    },
    // 根据关键字获取菜单列表
    getMenusByKeyword(keyword) {
      const menus = this.$store.state.sys.permissionMenus
      if (!menus || menus.length === 0) return []

      // 定义关键字到父路径的映射
      const pathMap = {
        '监控': '/monitor',
        '监控分析': '/monitor',
        '设备管理': '/facility',
        '人力': '/personnel',
        '人力管理': '/personnel'
      }

      const parentPath = pathMap[keyword]
      if (!parentPath) return []

      return this.getMenusByParentPath(parentPath)
    },
    // 根据菜单获取图标
    getMenuIcon(menu) {
      if (!menu) return 'el-icon-menu'

      const url = menu.Url || ''
      const name = menu.MenuName || ''

      // 监控分析模块图标
      if (url === 'overview' || name.includes('总览')) return 'el-icon-data-board'
      if (url === 'devicestate' || name.includes('状态')) return 'el-icon-monitor'
      if (url === 'failure' || name.includes('故障')) return 'el-icon-warning'
      if (url === 'analysis' || name.includes('分析')) return 'el-icon-data-line'

      // 设备管理模块图标
      if (url === 'record' && name.includes('模具')) return 'el-icon-box'
      if (url === 'manage' && name.includes('设备管理')) return 'el-icon-setting'
      if (url === 'datathreshold' || name.includes('阈值')) return 'el-icon-s-tools'
      if (url === 'mold' || name.includes('档案')) return 'el-icon-goods'
      if (url === 'molduse' || name.includes('使用')) return 'el-icon-sold-out'

      // 人力管理模块图标
      if (url === 'dp' || name.includes('部门')) return 'el-icon-s-grid'
      if (url === 'record' && name.includes('员工')) return 'el-icon-s-custom'
      if (name.includes('考勤')) return 'el-icon-date'

      // 默认图标
      if (name.includes('管理')) return 'el-icon-setting'

      return 'el-icon-menu'
    },
    // 根据菜单获取图标颜色类
    getMenuIconClass(menu) {
      if (!menu) return ''

      const url = menu.Url || ''
      const name = menu.MenuName || ''

      // 监控分析模块图标
      if (url === 'overview') return 'icon-blue'
      if (url === 'devicestate') return 'icon-purple'
      if (url === 'failure') return 'icon-red'
      if (url === 'analysis') return 'icon-orange'

      // 设备管理模块图标
      if (url === 'manage') return 'icon-blue'
      if (url === 'datathreshold') return 'icon-green'
      if (url === 'mold') return 'icon-purple'
      if (url === 'molduse') return 'icon-orange'
      if (url === 'record' && name.includes('模具')) return 'icon-red'
      if (url === 'record' && name.includes('使用')) return 'icon-blue'

      // 人力管理图标
      if (url === 'dp') return 'icon-orange'
      if (url === 'record' && name.includes('员工')) return 'icon-green'

      return 'icon-default'
    },
    // 跳转到指定菜单
    navigateToMenu(menu) {
      if (menu.FullPath) {
        this.$router.push(menu.FullPath)
      } else if (menu.Url) {
        // 如果没有FullPath，尝试构建路径
        this.$router.push(`/${menu.Url}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  padding: 24px;
  background-color: #ffffff;
  // min-height: calc(100vh - 84px);
  overflow: auto;
  margin: 10px;
}

// 欢迎栏
.welcome-section {
  background: transparent;
  padding: 0 0 28px 0;
  margin-bottom: 28px;
  color: #303133;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #E4E7ED;

  .welcome-text {
    h2 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: #303133;
    }

    p {
      margin: 4px 0 0 0;
      font-size: 13px;
      color: #909399;
    }
  }
}

// 快捷入口区域
.quick-access-section {
  margin-bottom: 28px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 32px;
}

// 菜单区块
.menu-block {
  background: transparent;
  overflow: visible;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    // 无悬停效果，保持简洁
  }
}

// 区块头部
.block-header {
  padding: 0 0 16px 0;
  display: flex;
  align-items: center;
  color: #303133;
  border-bottom: 1px solid #E4E7ED;

  .block-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin-right: 12px;

    &.monitor-icon {
      background: #409EFF;
      color: white;
    }

    &.facility-icon {
      background: #67C23A;
      color: white;
    }

    &.personnel-icon {
      background: #E6A23C;
      color: white;
    }
  }

  .block-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }
}

// 区块内容
.block-content {
  padding: 16px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

// 菜单项
.menu-item {
  display: flex;
  align-items: center;
  padding: 14px 14px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent;
  border: none;
  border-bottom: 1px solid #e4e7edd7;
  position: relative;

  &:hover {
    background: #F5F7FA;

    .menu-item-text {
      color: #409EFF;
    }

    .menu-item-icon {
      color: #409EFF;
      background: rgba(64, 158, 255, 0.1);
    }
  }

  &:last-child {
    border-bottom: none;
  }

  .menu-item-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    margin-right: 12px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &.icon-blue {
      color: #409EFF;
      background: rgba(64, 158, 255, 0.08);
    }

    &.icon-purple {
      color: #909399;
      background: rgba(144, 147, 153, 0.08);
    }

    &.icon-red {
      color: #F56C6C;
      background: rgba(245, 108, 108, 0.08);
    }

    &.icon-orange {
      color: #E6A23C;
      background: rgba(230, 162, 60, 0.08);
    }

    &.icon-green {
      color: #67C23A;
      background: rgba(103, 194, 58, 0.08);
    }

    &.icon-default {
      color: #C0C4CC;
      background: rgba(192, 196, 204, 0.08);
    }
  }

  .menu-item-text {
    font-size: 16px;
    color: #606266;
    font-weight: 600;
    transition: all 0.2s;
  }
}

// 无菜单提示
.no-menu {
  text-align: center;
  padding: 32px;
  color: #909399;
  font-size: 14px;
}

// 统计卡片行
.stats-row {
  margin-bottom: 28px;
}

.stat-card {
  background: linear-gradient(to right, #fafafa, #ffffff);
  padding: 20px;
  display: flex;
  align-items: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border-left: 3px solid transparent;
  box-shadow: none;

  &:hover {
    background: #F5F7FA;
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    margin-right: 16px;
  }

  .stat-content {
    flex: 1;

    .stat-value {
      font-size: 28px;
      font-weight: 700;
      color: #303133;
      margin-bottom: 2px;
      line-height: 1;
    }

    .stat-label {
      font-size: 13px;
      color: #909399;
      font-weight: 400;
    }
  }

  // 不同颜色的卡片
  &.stat-blue {
    border-left-color: #409EFF;

    .stat-icon {
      background: rgba(64, 158, 255, 0.1);
      color: #409EFF;
    }
  }

  &.stat-orange {
    border-left-color: #E6A23C;

    .stat-icon {
      background: rgba(230, 162, 60, 0.1);
      color: #E6A23C;
    }
  }

  &.stat-red {
    border-left-color: #F56C6C;

    .stat-icon {
      background: rgba(245, 108, 108, 0.1);
      color: #F56C6C;
    }
  }

  &.stat-gray {
    border-left-color: #909399;

    .stat-icon {
      background: rgba(144, 147, 153, 0.1);
      color: #909399;
    }
  }
}

// 图表行
.chart-row {
  margin-bottom: 28px;
}

.chart-card {
  background: #ffffff;
  padding: 20px;
  height: 400px;
  display: flex;
  flex-direction: column;
  border: 1px solid #E4E7ED;
  box-shadow: none;

  .chart-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #E4E7ED;
    flex-shrink: 0;

    i {
      font-size: 20px;
      color: #409EFF;
      margin-right: 10px;
    }

    span {
      font-size: 15px;
      font-weight: 600;
      color: #303133;
    }
  }

  .no-data {
    text-align: center;
    padding: 120px 0;
    color: #909399;
    font-size: 14px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// 响应式布局
@media screen and (max-width: 768px) {
  .dashboard-container {
    padding: 16px;
  }

  .welcome-section {
    padding-bottom: 20px;
    margin-bottom: 20px;

    .welcome-text h2 {
      font-size: 20px;
    }

    .welcome-text p {
      font-size: 12px;
    }
  }

  .quick-access-section {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .stats-row {
    margin-bottom: 20px;

    .el-col {
      margin-bottom: 12px;
    }
  }

  .stat-card {
    padding: 16px;

    .stat-icon {
      width: 40px;
      height: 40px;
      font-size: 18px;
      margin-right: 12px;
    }

    .stat-content .stat-value {
      font-size: 24px;
    }

    .stat-content .stat-label {
      font-size: 12px;
    }
  }

  .block-header {
    padding: 0 0 12px 0;

    .block-icon {
      width: 36px;
      height: 36px;
      font-size: 18px;
    }

    .block-title {
      font-size: 15px;
    }
  }

  .block-content {
    padding: 12px 0 0 0;
  }

  .menu-item {
    padding: 12px 0;

    .menu-item-icon {
      width: 32px;
      height: 32px;
      font-size: 16px;
      margin-right: 10px;
    }

    .menu-item-text {
      font-size: 13px;
    }
  }

  .chart-row {
    margin-bottom: 20px;

    .el-col {
      margin-bottom: 12px;
    }
  }

  .chart-card {
    padding: 16px;
    height: 350px;
  }
}

@media screen and (min-width: 769px) and (max-width: 1200px) {
  .quick-access-section {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>